import React, { useState, useEffect } from "react";
import { useFormikContext } from "formik";
import _ from "lodash"
function ErrorMessage(message){
    const { errors } = useFormikContext();
   

    const [NextBtn, setNextBtn] = useState(false);
    if(Object.keys(errors).length = 0){
        setNextBtn(false);
    }
    if(!_.isNil(document.getElementById("asc-form-submit"))) {
        document.getElementById("asc-form-submit").addEventListener("click", function() {
            setNextBtn(true);
        });
    }
   

    return(
        <>
            {Object.keys(errors).length > 0 && NextBtn &&(
                <div className="validation-summary" role="alert">
                    <h4>The form could not be submitted for the following reasons:</h4>
                    <ul role="presentation">
                    {Object.values(message.errors).map((error, index) => (
                        <li key={index}>{error}</li>
                    ))}
                    </ul>
                </div>
            )} 
       </>
    )
}

export default ErrorMessage